const langKey = 'lang'

export function getLangFromLocalStorage() {
  const lang = localStorage.getItem(langKey)
  return lang ? lang : 'ja'
}

export function setLangInLocalStorage(lang) {
  localStorage.setItem(langKey, lang)
}
